import { Link, useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { ColorRing } from 'react-loader-spinner'
import Pagination from '@mui/material/Pagination';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import * as XLSX from "xlsx";
import { FileUploader } from "react-drag-drop-files";
import Swal from 'sweetalert2';
import * as debounce from 'lodash/debounce';
import { API_SERVER } from '../../EnvConfig/env_config';
import { Dialog, Zoom } from '@mui/material';
import ExcelJS from 'exceljs';
import { post } from './service';

export const PageNotFound = ({ open, text }) => {
    return (
        <main id="main" className="main" style={open ? {} : { margin: "0", background: "#cbdfef", height: "100vh" }}>
            <section className="py-3">
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-12 mb-5">
                            <center>
                                <div className="thankyou-img">
                                    <img src="./assets/img/coming-soon.jpg" className="img-fluid" alt='' />
                                </div>
                                <div className="thankyou-text mt-3">
                                    {text ?
                                        <h2 className="main-heading h4">{text}</h2>
                                        :
                                        <h2 className="main-heading h4">Page Not Found !.</h2>
                                    }

                                    <p>We're working hard to give you the best experience!</p>
                                    <Link to="/" className="btn text-light mt-3" style={{ background: '#314cb5' }}>
                                        Back to Login
                                    </Link>
                                </div>
                            </center>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    )
}
export const ImportButton = ({
    BulkSubmit,
    handleBulk,
    downloadFormat,
    children,
    Status = [],
    ErrorData,
    fileName = '',
    extraElement = false,
    setIsBulkEditDelete,
    isBulkEditDelete,
    isAdd = true,
    isUpdate = true,
    isDelete = true
}) => {

    return (
        <div className="w-100 bg-white border border-secondary rounded shadow-sm p-3">

            {/* Label */}
            <label className="form-label fw-medium text-dark mb-2">
                Bulk Upload <span className="text-danger">*</span>
            </label>

            {/* Radio Buttons */}
            {extraElement && (
                <div className="d-flex align-items-center gap-4 mb-2 small text-secondary">

                    {isAdd && (
                        <label className="form-check d-flex align-items-center gap-2 m-0">
                            <input
                                type="radio"
                                name="isbulkEditUpdate"
                                value="insert"
                                checked={isBulkEditDelete === "insert"}
                                onChange={(e) => setIsBulkEditDelete(e.target.value)}
                                className="form-check-input"
                            />
                            Add
                        </label>
                    )}

                    {isUpdate && (
                        <label className="form-check d-flex align-items-center gap-2 m-0">
                            <input
                                type="radio"
                                name="isbulkEditUpdate"
                                value="update"
                                checked={isBulkEditDelete === "update"}
                                onChange={(e) => setIsBulkEditDelete(e.target.value)}
                                className="form-check-input"
                            />
                            Update
                        </label>
                    )}

                    {isDelete && (
                        <label className="form-check d-flex align-items-center gap-2 m-0">
                            <input
                                type="radio"
                                name="isbulkEditUpdate"
                                value="delete"
                                checked={isBulkEditDelete === "delete"}
                                onChange={(e) => setIsBulkEditDelete(e.target.value)}
                                className="form-check-input"
                            />
                            Delete
                        </label>
                    )}

                </div>
            )}

            {/* Drop Zone */}
            <FileUploader
                classes="w-100"
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={
                    <div
                        className="d-flex align-items-center justify-content-center gap-2 w-100 py-3 border border-2 border-dashed border-dark rounded cursor-pointer bg-light hover-shadow"
                        style={{ cursor: "pointer" }}
                    >
                        <i className="fa fa-upload text-primary"></i>
                        <span className="text-muted">
                            {fileName ? fileName : "Upload Excel File (.xlsx)"}
                        </span>
                    </div>
                }
            />

            {/* Action Buttons */}
            <div className="d-flex align-items-center gap-3 mt-3 lms-new-button">
                <button
                    type="button"
                    className="btn save-btn btn-sm"
                    onClick={handleBulk}
                >
                    <i className="fa fa-upload me-1"></i> Upload
                </button>

                <button
                    type="button"
                    className="btn btn-link p-0 small fw-semibold text-dark"
                    onClick={downloadFormat}
                >
                    Download Format <i className="fa fa-download ms-1"></i>
                </button>
            </div>

            {/* Status Display */}
            {Status?.SuccessCount >= 0 && (
                <div className="mt-3 small fw-medium d-flex gap-4">

                    <span className="text-success">
                        Success : {Status?.SuccessCount}
                    </span>

                    <span className="text-danger d-flex align-items-center gap-1">
                        Error : {Status?.ErrorCount}

                        {Status?.ErrorCount > 0 && (
                            <i
                                className="fa fa-download text-danger"
                                style={{ cursor: "pointer" }}
                                onClick={ErrorData}
                            ></i>
                        )}
                    </span>

                </div>
            )}

            {children}
        </div>
    );
};
export const TextareaBox = (props) => {
    
    const { divclassname = "w-full ", rows, name, zoom, inputrefs, onChange, label, error, onClick, id, divstyle, maxLength, value, required, inputstyle, onKeyDown, onFocus, InfoDetails, onBlur, pattern, type = "text", inputclassname, placeholder, disabled } = props;
    const [zoomIn, setZoomIn] = useState(false);

    const handleZoomIn = async () => {
        await setZoomIn(true);
    }
    const handleZoomOut = async () => {
        await setZoomIn(false);
    }
    return (
        <div className={`fields ${divclassname} ${zoom && "position-relative"}`} style={divstyle}>
            {label !== "" && label && <label className={`block text-sm font-medium text-gray-700 mb-1 ${error && value?.trim() === "" && "text-error-color"}`} title={label}>{label}{required && <span className="text-danger">*</span>}</label>
            }
            <textarea
                rows={rows}
                className={`${inputclassname} block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-blue-500 transition duration-200 outline-none`}
                id={id}
                name={name}
                maxLength={maxLength}
                style={inputstyle}
                disabled={disabled}
                ref={ref => (inputrefs.current[id] = ref)}
                onKeyDown={onKeyDown}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onClick={onClick}
                pattern={pattern}
                type={type ? type : "text"}
                value={ typeof value === 'string' ? value.toUpperCase() : value || ''}
                placeholder={placeholder}
                autoComplete="off"
            />
            {zoom && (zoomIn ? <i className="fa-solid fa-compress arrow zoom-icon-placement" onClick={() => handleZoomOut()}></i> :
                <i className="fas fa-expand arrow zoom-icon-placement" onClick={() => handleZoomIn()}></i>
            )}
            {error && value?.trim() === "" && <div className="error-msg">{error}</div>}

            {zoomIn &&
                <Dialog
                    open={zoomIn}
                    onClose={handleZoomOut}
                    keepMounted
                    maxWidth="md"
                    fullWidth
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: { enter: 1000, exit: 500 } }}
                >

                    <textarea
                        rows={rows}
                        className={`form-control ${inputclassname} ${error && value?.trim() === "" && "border-error-color"}`}
                        id={id}
                        name={name}
                        maxLength={maxLength}
                        style={inputstyle}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        onChange={onChange}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onClick={onClick}
                        pattern={pattern}
                        type={type ? type : "text"}
                        value={value}
                        placeholder={placeholder}
                        autoComplete="off"
                    />
                </Dialog>
            }
        </div>
    )
}
export function convertToNumber(value) {
    let data = value.replace(/[^0-9]/g, '');
    return isNaN(data) ? '' : data;
}
export const formatDate = (date) => {
    if (!date) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const monthShort = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    return `${day}-${monthShort}-${year}`;
};


export const ReverseFormatDate = (inputDate) => {
    let convertedDate = null;

    if (inputDate && inputDate.trim() !== '') {
        const [day, month, year] = inputDate.split('-');

        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const monthIndex = months.findIndex(m => m === month);

        if (monthIndex !== -1) {
            convertedDate = new Date(year, monthIndex, day);
        }
    }

    return convertedDate;
}


export const dateFormate = (e) => {
    let dateArr = (e?.toString() || '').split(' ');
    if (dateArr.length >= 4) {
        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
        return dateArr
    } else {
        return dateArr = '';
    }
}

export const getBeforeDate = (lastDay = 7, today = new Date()) => {

    const forBeforeDays = new Date();

    forBeforeDays.setDate(today.getDate() - lastDay);

    return dateFormate(forBeforeDays);

};


export const ClearSession = () => {
    const cookies = new Cookies();
    const navigate = useNavigate()
    cookies.remove('token')
    cookies.remove('loginUserCode')
    cookies.remove('isBackOfficeUser')
    cookies.remove('userName')
    cookies.remove('CookieConsentByFineshop')
    cookies.remove('csrftoken')
    cookies.remove('salesPersonCode')

    setTimeout(() => {
        navigate('/login');
    }, 1000)
}

const getSearchingList = async ({ PageName, setFilterList }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode').toString();
    let data = {
        Token, LoginUserCode, PageName: PageName
    }
    post(`${API_SERVER}/api/Dashboard/BindSearchingColumnList`, { ...data }, (res) => {
        if (res.status === 'SUCCESS') {
            setFilterList(res.getSearchingList);
        }
        else if (res.message === "EXPIRED") {
            ClearSession();
        }
    });
};

export const BindGrid = ({ tableData, filterData, setFilterData, searchHandle, loading, handleEditData, handleDeleteData, FormName }) => {
    const [FilterList, setFilterList] = useState([]);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    useEffect(() => {
        getSearchingList({ PageName: FormName, setFilterList })
    }, []);
    const handleHighlight = (index) => {
        setHighlightedRowIndex(index === highlightedRowIndex ? null : index);
    };
    useEffect(() => {
        if (FilterList.length > 0) {
            setFilterData({ ...filterData, SearchFieldValue: FilterList[0].searchingValue });
        }
    }, [FilterList]);

    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(20)))

    const deleteHandleConfirm = (ID) => {

        Swal.fire({
            title: "Do you want to Delete this Record ?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            allowOutsideClick: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire(
                    {
                        title: "Deleted!",
                        text: "Your record has been deleted.",
                        icon: "success"
                    });
                handleDeleteData(ID);
            }
        });
    }
    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                <div className="filter-section d-flex gap-2">
                                    <span className=" d-flex gap-1">
                                        <span className='select_records_filter'>
                                            <select className='filter-select'
                                                placeholder='Please select'
                                                value={filterData.SearchFieldValue}
                                                onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                {FilterList ? (FilterList.map((item, index) => (
                                                    <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                ))) : (<></>)}
                                            </select>
                                        </span>
                                        <span className='select_records_filter' >
                                            <select className='filter-select' value={filterData.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                <option value="1">Exactly</option>
                                                <option value="2">Contains</option>
                                                <option value="3">Start With</option>
                                            </select>
                                        </span>
                                        <span className=' filter-search-bar d-flex gap-2 form-control'>
                                            <input
                                                name="query"
                                                value={filterData.SearchText}
                                                onChange={(e) => {
                                                    setFilterData({ ...filterData, SearchText: e.target.value });
                                                }}
                                                placeholder="Search"
                                                title="Enter search keyword"
                                            />
                                            <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                searchHandle();
                                            }}>
                                                <i className="bi bi-search" />
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.totalRecord > 0 ?
                                                    (

                                                        tableData?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">

                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    {Object.keys(tableData.gridData[0]).map((header, index) => (

                                                                        (<th key={index}>{header}</th>)

                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.gridData !== null ?
                                                                    (
                                                                        (tableData?.gridData)?.map((item, rowIndex) => (
                                                                            <tr key={rowIndex} className={`TableTrhover ${highlightedRowIndex === rowIndex ? 'highlighted' : ''}`} onClick={() => handleHighlight(rowIndex)}>
                                                                                {Object.values(item).map((value, cellIndex) => (
                                                                                    <td key={cellIndex}>{value ?
                                                                                        (
                                                                                            (Object.keys(item)[cellIndex] === 'Edit' || Object.keys(item)[cellIndex] === 'Del') ?
                                                                                                (
                                                                                                    (Object.keys(item)[cellIndex] === 'Edit' ? (
                                                                                                        <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(value.toString())}>
                                                                                                            <i className="bi bi-pencil-square" />
                                                                                                        </button>) : (<button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => deleteHandleConfirm(value.toString())}>
                                                                                                            <i className="bi bi-trash3" />
                                                                                                        </button>)
                                                                                                    )
                                                                                                ) : (value)
                                                                                        ) : (<></>)
                                                                                    }
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<>No Record Found !.</>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                (
                                                    <Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => setFilterData({ ...filterData, PageIndex: value.toString() })} shape="rounded" />)
                                                :
                                                (<></>)
                                            }
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center' style={{ minHeight: '200px', paddingLeft: "500px" }}>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        </>
    )
}

export const BindReportGrid = ({ tableData, filterData, setFilterData, FormName, searchHandle, currentPageNo,
    handleChange1, exporting, Filter = true, handleSorting, sortConfig,
    handlePrintButton, loading, handleEditData, handleDeleteData, handleCheckboxChange, handleAllchange, clickableColumn, 
    onColumnClick, setShowInvoiceModal 
}) => {
    const [MainData, setMainData] = useState(tableData?.Data ? tableData?.Data : []);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize)));
    const [FilterList, setFilterList] = useState([]);
    useEffect(() => {
        getSearchingList({ PageName: FormName, setFilterList })
    }, []);

    const handleHighlight = (index) => {
        setHighlightedRowIndex(index === highlightedRowIndex ? null : index);

    };

    useEffect(() => {
        if (FilterList.length > 0) {
            setFilterData({ ...filterData, SearchFieldValue: FilterList[0].searchingValue });
        }
    }, [FilterList]);


    const deleteHandleConfirm = (ID) => {
        Swal.fire({
            title: 'Do you want to Delete this Record ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteData(ID);
            }
        });
    }

    const finalHeaderKeys = tableData?.HeadersKey?.filter(
        (key, index) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );

    const finalHeadersValue = tableData?.HeadersValue?.filter(
        (key) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );

    useEffect(() => {
        setMainData(tableData?.Data)
    }, [tableData]);

    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.TotalRecord !== undefined && tableData.TotalRecord !== null ?
                                            (`Total Records : ${tableData.TotalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                {Filter && FormName === 'VatTaxMaster' ?
                                    <div className="filter-section d-flex gap-2">
                                        <span className=" d-flex gap-1">
                                            <span className='select_records_filter'>
                                                <select className='filter-select'
                                                    placeholder='Please select'
                                                    value={filterData?.SearchFieldValue ? filterData?.SearchFieldValue : ""}
                                                    onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                    {FilterList ? (FilterList.map((item, index) => (
                                                        <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                    ))) : (<></>)}
                                                </select>
                                            </span>
                                            <span className='select_records_filter' >
                                                <select className='filter-select' onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                    <option value="1">Exactly</option>
                                                    <option value="2">Contains</option>
                                                    <option value="3">Start With</option>
                                                </select>
                                            </span>
                                            <span className=' filter-search-bar d-flex gap-2 form-control'>
                                                <input
                                                    name="query"
                                                    value={filterData?.SearchText ? filterData?.SearchText : ""}
                                                    onChange={(e) => {
                                                        setFilterData({ ...filterData, SearchText: e.target.value });
                                                    }}
                                                    placeholder="Search"
                                                    title="Enter search keyword"
                                                />
                                                <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                    searchHandle();
                                                }}>
                                                    <i className="bi bi-search" />
                                                </button>
                                            </span>
                                        </span>
                                    </div>
                                    : <></>}
                            </div>

                            <div className="recoard-bata service-content-area">

                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive custom-table-responsive" >
                                                <table className="table table-bordered table-striped ">
                                                    <thead>
                                                        <tr className='light-bg'>
                                                            {tableData?.Actions && tableData.Actions.length > 0 && (
                                                                <th>
                                                                    {tableData.Actions.includes('CheckBox') && handlePrintButton !== "PrintInvoiceNo" && (
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input mt-1 ml-1 ms-1"
                                                                            checked={MainData?.every(item => item.checkStatus)}
                                                                            onChange={handleAllchange}
                                                                        />
                                                                    )}
                                                                    Actions
                                                                </th>
                                                                
                                                            )}
                                                            {finalHeaderKeys?.map((th, headIndex) => (
                                                                <th key={`th${headIndex || 0}`} style={{ cursor: 'pointer' }}
                                                                    onClick={() =>
                                                                        handleSorting ?
                                                                            handleSorting(finalHeadersValue[headIndex]) : ''}
                                                                >
                                                                    {th}
                                                                    {
                                                                        (sortConfig?.SortColumn !== null
                                                                            && sortConfig?.SortOrder !== null
                                                                            && sortConfig?.SortColumn === finalHeadersValue[headIndex]) ?
                                                                            (
                                                                                <>

                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>

                                                                                </>
                                                                            )
                                                                    }

                                                                </th> || <></>
                                                            ))}

                                                        </tr>
                                                    </thead>
                                                    <tbody >

                                                        {MainData?.map((item, bodyIndex) => (

                                                            <tr className={`TableTrhover ${highlightedRowIndex === bodyIndex ? 'highlighted' : ''}`} key={`row${bodyIndex}`} onClick={() => handleHighlight(bodyIndex)}>
                                                                {tableData?.Actions && tableData?.Actions.length > 0 ? (
                                                                    <td key={`tdAction${bodyIndex}`} onClick={() => handleHighlight(item.Edit)}  >
                                                                        {tableData.Actions?.map((btn, index) => (
                                                                            <span key={index}>
                                                                                {btn === 'Edit' ? <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(item, bodyIndex)}>
                                                                                    <i className="bi bi-pencil-square" />
                                                                                </button> : (<></>)}
                                                                                {btn === 'Del' ? <button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => deleteHandleConfirm(item, bodyIndex)}>
                                                                                    <i className="bi bi-trash3" />
                                                                                </button> : (<></>)}
                                                                                {btn === 'Print' ? <i className="fa-solid fa-print me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintButton(item, bodyIndex)} style={{ cursor: "pointer", color: "green" }} /> : (<></>)}
                                                                                {btn === 'Map' && item.Map !== "" ? (
                                                                                    <a
                                                                                        href={item.Map}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        <i
                                                                                            className="fas fa-map-marker-alt"
                                                                                            title="Map"
                                                                                            key={`row${bodyIndex}print${index}`}
                                                                                            style={{ cursor: "pointer", color: "green" }}
                                                                                        />
                                                                                    </a>
                                                                                ) : null}

                                                                                {btn === 'Detail' ? <i className="fa fa-info-circle text-info me-2" title='Detail' role="button" key={`row${bodyIndex}Detail${index}`} /> : (<></>)}
                                                                                {btn === 'CheckBox' && item?.CheckBox?.trim() !== "" && (
                                                                                    <input
                                                                                        className="form-check-input mt-1 ms-2"
                                                                                        type="checkbox"
                                                                                        checked={item?.checkStatus || false}
                                                                                        id={item?.CheckBox}
                                                                                        onChange={(e) =>
                                                                                            handleCheckboxChange(e.target.checked, item, bodyIndex)
                                                                                        }
                                                                                    />
                                                                                )}

                                                                            </span>
                                                                        ))}
                                                                    </td>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {finalHeadersValue?.map((key, tdIndex) => (
                                                                    <td key={`key${tdIndex}`}>
                                                                        {key === clickableColumn ? (
                                                                            <span
                                                                                style={{
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                    textDecoration: "underline"
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setShowInvoiceModal(true);
                                                                                    onColumnClick && onColumnClick(item[key]); // ✅ correct
                                                                                }}
                                                                            >
                                                                                {item[key]}
                                                                            </span>
                                                                        ) : (
                                                                            item[key]
                                                                        )}
                                                                    </td>
                                                                ))}

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </div>

                                            {countNo > 1 ?

                                                <Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => {
                                                    setFilterData({ ...filterData, PageIndex: value.toString() })
                                                    handleChange1(event, value)
                                                }} shape="rounded" />
                                                : ''}
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center' style={{ minHeight: '200px', paddingLeft: "500px" }}>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        </>
    )
}



export const BindReportGridwithoutceckbox = ({ tableData, filterData, setFilterData, FormName, searchHandle, currentPageNo,
    handleChange1, exporting, Filter = true, handleSorting, sortConfig,
    handlePrintButton, loading, handleEditData, handleDeleteData, handleCheckboxChange, handleAllchange
}) => {
    const [MainData, setMainData] = useState(tableData?.Data ? tableData?.Data : []);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize)));
    const [FilterList, setFilterList] = useState([]);
    useEffect(() => {
        getSearchingList({ PageName: FormName, setFilterList })
    }, []);

    const handleHighlight = (index) => {
        setHighlightedRowIndex(index === highlightedRowIndex ? null : index);

    };

    useEffect(() => {
        if (FilterList.length > 0) {
            setFilterData({ ...filterData, SearchFieldValue: FilterList[0].searchingValue });
        }
    }, [FilterList]);


    const deleteHandleConfirm = (ID) => {
        Swal.fire({
            title: 'Do you want to Delete this Record ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteData(ID);
            }
        });
    }

    const finalHeaderKeys = tableData?.HeadersKey?.filter(
        (key, index) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );

    const finalHeadersValue = tableData?.HeadersValue?.filter(
        (key) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );

    useEffect(() => {
        setMainData(tableData?.Data)
    }, [tableData]);

    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.TotalRecord !== undefined && tableData.TotalRecord !== null ?
                                            (`Total Records : ${tableData.TotalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                {Filter && FormName === 'VatTaxMaster' ?
                                    <div className="filter-section d-flex gap-2">
                                        <span className=" d-flex gap-1">
                                            <span className='select_records_filter'>
                                                <select className='filter-select'
                                                    placeholder='Please select'
                                                    value={filterData?.SearchFieldValue ? filterData?.SearchFieldValue : ""}
                                                    onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                    {FilterList ? (FilterList.map((item, index) => (
                                                        <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                    ))) : (<></>)}
                                                </select>
                                            </span>
                                            <span className='select_records_filter' >
                                                <select className='filter-select' onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                    <option value="1">Exactly</option>
                                                    <option value="2">Contains</option>
                                                    <option value="3">Start With</option>
                                                </select>
                                            </span>
                                            <span className=' filter-search-bar d-flex gap-2 form-control'>
                                                <input
                                                    name="query"
                                                    value={filterData?.SearchText ? filterData?.SearchText : ""}
                                                    onChange={(e) => {
                                                        setFilterData({ ...filterData, SearchText: e.target.value });
                                                    }}
                                                    placeholder="Search"
                                                    title="Enter search keyword"
                                                />
                                                <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                    searchHandle();
                                                }}>
                                                    <i className="bi bi-search" />
                                                </button>
                                            </span>
                                        </span>
                                    </div>
                                    : <></>}
                            </div>

                            <div className="recoard-bata service-content-area">

                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive custom-table-responsive" >
                                                <table className="table table-bordered table-striped ">
                                                    <thead>
                                                        <tr className='light-bg'>
                                                            {/*{tableData?.Actions && tableData.Actions.length > 0 && (*/}
                                                            {/*    <th>*/}
                                                            {/*        {tableData.Actions.includes('CheckBox') && handlePrintButton !== "PrintInvoiceNo" && (*/}
                                                            {/*            <input*/}
                                                            {/*                type="checkbox"*/}
                                                            {/*                className="form-check-input mt-1 ml-1 ms-1"*/}
                                                            {/*                checked={MainData?.every(item => item.checkStatus)}*/}
                                                            {/*                onChange={handleAllchange}*/}
                                                            {/*            />*/}
                                                            {/*        )}*/}
                                                            {/*        Actions*/}
                                                            {/*    </th>*/}

                                                            {/*)}*/}
                                                            {finalHeaderKeys?.map((th, headIndex) => (
                                                                <th key={`th${headIndex || 0}`} style={{ cursor: 'pointer' }}
                                                                    onClick={() =>
                                                                        handleSorting ?
                                                                            handleSorting(finalHeadersValue[headIndex]) : ''}
                                                                >
                                                                    {th}
                                                                    {
                                                                        (sortConfig?.SortColumn !== null
                                                                            && sortConfig?.SortOrder !== null
                                                                            && sortConfig?.SortColumn === finalHeadersValue[headIndex]) ?
                                                                            (
                                                                                <>

                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>

                                                                                </>
                                                                            )
                                                                    }

                                                                </th> || <></>
                                                            ))}

                                                        </tr>
                                                    </thead>
                                                    <tbody >

                                                        {MainData?.map((item, bodyIndex) => (

                                                            <tr className={`TableTrhover ${highlightedRowIndex === bodyIndex ? 'highlighted' : ''}`} key={`row${bodyIndex}`} onClick={() => handleHighlight(bodyIndex)}>
                                                                {tableData?.Actions && tableData?.Actions.length > 0 ? (
                                                                    <td key={`tdAction${bodyIndex}`} onClick={() => handleHighlight(item.Edit)}  >
                                                                        {tableData.Actions?.map((btn, index) => (
                                                                            <span key={index}>
                                                                                {btn === 'Edit' ? <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(item, bodyIndex)}>
                                                                                    <i className="bi bi-pencil-square" />
                                                                                </button> : (<></>)}
                                                                                {btn === 'Del' ? <button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => deleteHandleConfirm(item, bodyIndex)}>
                                                                                    <i className="bi bi-trash3" />
                                                                                </button> : (<></>)}
                                                                                {btn === 'Print' ? <i className="fa-solid fa-print me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintButton(item, bodyIndex)} style={{ cursor: "pointer", color: "green" }} /> : (<></>)}
                                                                                {btn === 'Map' && item.Map !== "" ? (
                                                                                    <a
                                                                                        href={item.Map}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        <i
                                                                                            className="fas fa-map-marker-alt"
                                                                                            title="Map"
                                                                                            key={`row${bodyIndex}print${index}`}
                                                                                            style={{ cursor: "pointer", color: "green" }}
                                                                                        />
                                                                                    </a>
                                                                                ) : null}

                                                                                {btn === 'Detail' ? <i className="fa fa-info-circle text-info me-2" title='Detail' role="button" key={`row${bodyIndex}Detail${index}`} /> : (<></>)}
                                                                                {btn === 'CheckBox' && item?.CheckBox?.trim() !== "" && (
                                                                                    <input
                                                                                        className="form-check-input mt-1 ms-2"
                                                                                        type="checkbox"
                                                                                        checked={item?.checkStatus || false}
                                                                                        id={item?.CheckBox}
                                                                                        onChange={(e) =>
                                                                                            handleCheckboxChange(e.target.checked, item, bodyIndex)
                                                                                        }
                                                                                    />
                                                                                )}

                                                                            </span>
                                                                        ))}
                                                                    </td>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {finalHeadersValue?.map((key, tdIndex) => (

                                                                    <td key={`key${tdIndex}`}>{item[key]}</td>
                                                                ))}

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </div>

                                            {countNo > 1 ?

                                                <Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => {
                                                    setFilterData({ ...filterData, PageIndex: value.toString() })
                                                    handleChange1(event, value)
                                                }} shape="rounded" />
                                                : ''}
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center' style={{ minHeight: '200px', paddingLeft: "500px" }}>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        </>
    )
}

export const BindReportGridWithCheckBox = ({ tableData, filterData, setFilterData, loading, setformData, formData, checkBoxColumnName, Quantity, handleCheckboxChange, handleAllchange, handleInputBoxValue }) => {

    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(20)))
    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">

                                                {tableData?.totalRecord > 0 ? (
                                                    tableData?.totalRecord !== null ? (
                                                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    {Object.keys(tableData.Data[0]).map((header, index) => (
                                                                        <th key={index}>
                                                                            {header === checkBoxColumnName ? (
                                                                                <>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="chkAll"
                                                                                        onChange={handleAllchange}
                                                                                    /> ALL
                                                                                </>
                                                                            ) : (
                                                                                header
                                                                            )}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.Data !== null ? (
                                                                    (tableData?.Data)?.map((item, rowIndex) => (
                                                                        <tr key={rowIndex}>
                                                                            {Object.values(item).map((value, cellIndex) => (
                                                                                <td key={cellIndex}>
                                                                                    {value ? (
                                                                                        (Object.keys(item)[cellIndex] === checkBoxColumnName) ? (
                                                                                            <>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="chkCheck"
                                                                                                    id={value}
                                                                                                    onChange={handleCheckboxChange}
                                                                                                />
                                                                                            </>
                                                                                        ) : (Object.keys(item)[cellIndex] === Quantity) ? (
                                                                                            <>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control Quantity"
                                                                                                    id="txtReturnItemQuantity"
                                                                                                    placeholder="Enter Quantity"
                                                                                                    onKeyUp={handleInputBoxValue}
                                                                                                />
                                                                                            </>
                                                                                        ) : (value)
                                                                                    ) : (<></>)}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))
                                                                ) : (<></>)}
                                                            </tbody>
                                                        </table>
                                                    ) : (<>No Record Found !.</>)
                                                ) : (<>No Record Found !.</>)}

                                            </div>
                                            {countNo > 1 ?
                                                (<Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => setFilterData({ ...filterData, PageIndex: value.toString() })} shape="rounded" />)
                                                :
                                                (<></>)
                                            }
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center'>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        </>
    )
}

export const BindReportGridWithPrint = ({ tableData, filterData, setFilterData, loading, handlePrintButton, PrintColumnName }) => {
    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(20)))
    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.totalRecord > 0 ?
                                                    (

                                                        tableData?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">

                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    {Object.keys(tableData.gridData[0]).map((header, index) => (
                                                                        <th key={index}>
                                                                            {header === PrintColumnName ?
                                                                                ('Print')
                                                                                :
                                                                                (header)
                                                                            }
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.gridData !== null ?
                                                                    (
                                                                        (tableData?.gridData)?.map((item, rowIndex) => (
                                                                            <tr key={rowIndex} >
                                                                                {Object.values(item).map((value, cellIndex) => (
                                                                                    <td key={cellIndex}>{value ?
                                                                                        (
                                                                                            (Object.keys(item)[cellIndex] === PrintColumnName) ?
                                                                                                (
                                                                                                    <>
                                                                                                        <button title="Print" className="btn btn-link text-success btn-sm" onClick={() => handlePrintButton(value.toString())}>
                                                                                                            <i className="bi bi-printer" />
                                                                                                        </button>
                                                                                                    </>
                                                                                                ) : (value)
                                                                                        ) : (<></>)
                                                                                    }
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<>No Record Found !.</>)

                                                    ) : (<>No Record Found !.</>)}
                                            </div>
                                            {countNo > 1 ?
                                                (<Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => setFilterData({ ...filterData, PageIndex: value.toString() })} shape="rounded" />)
                                                :
                                                (<></>)
                                            }
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center'>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        </>
    )
}

export const exportToExcel = (data, fileName) => {
    try {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        console.log("Export successful!");
    } catch (error) {
        console.error("Error exporting to Excel:", error);
    }
}

export const exportToExcelHeader = async (handleApiUrl, data, fileName, enableAlternateColor = false, enableHeaderColor = true, enableFilters = false) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const apiUrl = handleApiUrl;
    const requestBody = data;
    requestBody.token = Token;

    const loginCodeString = String(LoginUserCode);
    requestBody.loginUserCode = loginCodeString;

    const requestHeaders = {
        'Content-Type': 'application/json',

    };
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res.Status === "SUCCESS") {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet 1', {
                views: [{ state: 'frozen', ySplit: 1 }],
            });

            // Example: Set header row to bold and background color
            const headerRow = worksheet.addRow(res?.HeadersKey?.length > 0
                ? res.HeadersKey.filter((key) => {
                    return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                })
                : Array.from(
                    new Set(
                        res?.Data?.flatMap((data) => Object.keys(data))
                            .filter((columnName) => !res?.HideColumns?.includes(columnName))
                    )
                ))


            const headerKey = (res?.HeadersKey?.length > 0 && res?.HeadersValue?.length > 0)
                ? res.HeadersValue.filter((key) => {
                    return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                })
                : Array.from(
                    new Set(
                        res.Data?.flatMap((data) => Object.keys(data))
                            .filter((columnName) => !res?.HideColumns?.includes(columnName))
                    )
                );


            headerRow.font = { bold: true };
            if (enableHeaderColor) {
                headerRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'AAAAAA' },
                };
            }

            // Example: Enable filters
            if (enableFilters) {
                worksheet.autoFilter = {
                    from: { row: 1, column: 1 },
                    to: { row: 1, column: headerKey.length },
                };
            }

            // Example: Set alternate row background color
            for (let i = 2; i <= res.Data.length + 1; i++) {
                const row = worksheet.getRow(i);

                if (enableAlternateColor && i % 2 === 0) {
                    row.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'DDDDDD' },
                    };
                }

                row.values = res.HeadersValue?.length > 0 ?
                    res.HeadersValue?.map((key) => res.Data[i - 2][key])
                    : headerKey?.map((key) => res.Data[i - 2][key]);
            }

            // Set column widths to fit content
            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const length = cell.value ? String(cell.value).length : 0;
                    maxLength = Math.max(maxLength, length);
                });
                column.width = maxLength < 12 ? 12 : maxLength; // Set a minimum width to avoid extremely narrow columns
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const data = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else if (res.Status === 'ERROR') {

        }
        else if (res.Status === 'UNAUTHORIZED') {

        }
    } catch (err) {

    }
};



const AutoComplete = async ({ setOnState, Type, Prefix, ContextKey = '', ContextKey2 = '' }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode');
    let data = { Token, LoginUserCode, Type, Prefix, ContextKey, ContextKey2 }

    await fetch(`${API_SERVER}/api/AutoComplete/AutoComplete`,
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === "SUCCESS") {
                setOnState(res.autoCompleteData?.map(item => item.values));
            }
            else if (res.message === "EXPIRED") {
                ClearSession();
            }
        }).catch((err) => {
            toast.error(err, {
                position: 'top-center',
            })
        });
}

export const BindAutoCompleteOnLoad = async ({ setOnState, Type, Prefix, ContextKey = '', ContextKey2 = '' }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode').toString();
    let data = { Token, LoginUserCode, Type, Prefix, ContextKey, ContextKey2 }

    await fetch(`${API_SERVER}/api/AutoComplete/AutoComplete`,
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            setOnState([])
            if (res.status === "SUCCESS") {
                setOnState(res.autoCompleteData?.map(item => item.values));
            }
            else if (res.message === "EXPIRED") {
                ClearSession();
            }
        }).catch((err) => {
            toast.error(err, {
                position: 'top-center',
            })
        });
}

export const BindAutoComplete = debounce(AutoComplete, 500);

export const Amount = (Value) => {
    return Value.replace(/[^0-9.]/g, '').replace(/(\.\d\d)\d+/, '$1');
}

export const Number = (Value) => {
    return Value.replace(/[^0-9]/g, '');
}

export const setFocus = (ID) => {
    const element = document.getElementById(ID);
    if (element) {
        element.focus()
    }
}

export const setDisabled = (ID, status) => {
    const element = document.getElementById(ID);
    if (element) {
        element.disabled = status;
    }
};

export const GetDate = (Day) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + Day);
    return formatDate(currentDate);
}

export const OpenBase64Pdf = (pdfBase64, DocName, Target) => {
    // Check if the device is mobile
    if (window.innerWidth <= 767) {
        // For mobile devices, open a new tab with a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = `data:application/pdf;base64,${pdfBase64}`;
        downloadLink.download = `${DocName}.pdf`;
        downloadLink.click();
    } else {
        // For desktop devices, open a new window with the embedded PDF
        const pdfWindow = window.open('', Target);
        if (pdfWindow) {
            pdfWindow.document.write(`
                <html>
                    <head>
                        <title>Lesken PDF Viewer</title>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    </head>
                    <body style="margin:0;">
                        <embed width="100%" height="100%" src="data:application/pdf;base64,${pdfBase64}#zoom=100" type="application/pdf">
                    </body>
                </html>
            `);
        }
    }
}

export const setTitle = async (PageUrl, setOpen) => {
    if (window.innerWidth < 1200) {
        setOpen(false)
    }
    const cookies = new Cookies();
    const Token = await cookies.get('token').toString();
    const LoginUserCode = await cookies.get('loginUserCode').toString();
    const data = {
        Token: Token,
        LoginUserCode: LoginUserCode,
        PageUrl: PageUrl,
    }
    await fetch(`${API_SERVER}/api/User/ValidateUserPageAccess`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json"
        }
    }
    ).then(async (response) => {
        let res = await response.json();
        if (res.status === "SUCCESS") {
            document.title = res.menuText;
        }

    })
}

export const UserTable = ({ loading, handleClear, currentPageNo, handleChange, filterData, searchHandle, filterList, setColoredRow, ColoredRow, setFilterData, handleEditData, tableData, getUserData, handleDelete }) => {


    //const [type, setType] = useState('')
    //const [pageIndex, setPageIndex] = useState('')
    const [SessionClear, SetSessionClear] = useState(false);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);

    const handleHighlight = (index) => {
        setHighlightedRowIndex(index === highlightedRowIndex ? null : index);
    };
    const handleDeleteConfirm = (UserID) => {
        Swal.fire({
            title: 'Do you want to Delete this Record ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                handleDelete(UserID);
            }
        });
    }




    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(20)))
    useEffect(() => {
        getUserData()
    }, [])


    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                <div className="filter-section d-flex gap-2">
                                    <span className=" d-flex gap-1">
                                        <span className='select_records_filter'>
                                            <select className='filter-select'
                                                placeholder='Please select'
                                                value={filterData.SearchFieldValue}
                                                onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                {filterList ? (filterList.map((item, index) => (
                                                    <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                ))) : (<></>)}
                                            </select>
                                        </span>
                                        <span className='select_records_filter' >
                                            <select className='filter-select' value={filterData.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                <option value="1">Exactly</option>
                                                <option value="2">Contains</option>
                                                <option value="3">Start With</option>
                                            </select>
                                        </span>
                                        <span className=' filter-search-bar d-flex gap-2 form-control'>
                                            <input
                                                name="query"
                                                value={filterData.SearchText}
                                                onChange={(e) => {
                                                    setFilterData({ ...filterData, SearchText: e.target.value });
                                                }}
                                                placeholder="Search"
                                                title="Enter search keyword"
                                            />
                                            <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                searchHandle();
                                            }}>
                                                <i className="bi bi-search" />
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.length !== 0 ?
                                                    (
                                                        (tableData?.totalRecord !== null) ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    <th>{"Edit"}</th>
                                                                    <th>{"Del"}</th>
                                                                    <th>{tableData.hUserCode}</th>
                                                                    <th>{tableData.hSalesPersonCode}</th>
                                                                    <th>{tableData.hUserName}</th>
                                                                    <th>{tableData.hGroupName}</th>
                                                                    <th>{tableData.hWarehouse}</th>
                                                                    <th>{tableData.hEmailID}</th>
                                                                    <th>{tableData.hMobileNo}</th>
                                                                    <th>{tableData.hDateOfJoining}</th>
                                                                    <th>{tableData.hAddress}</th>
                                                                    <th>{tableData.hCity}</th>
                                                                    <th>{tableData.hPinCode}</th>
                                                                    <th>{tableData.hActive}</th>
                                                                    <th>{tableData.hAllowBackDateTransaction}</th>
                                                                    <th>{tableData.hCreatedBy}</th>
                                                                    <th>{tableData.hCreatedDate}</th>
                                                                    <th>{tableData.hCreatedByIPAddress}</th>
                                                                    <th>{tableData.hModifiedBy}</th>
                                                                    <th>{tableData.hModifiedDate}</th>
                                                                    <th>{tableData.hModifiedByIPAddress}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.getUserMasterData !== null ?
                                                                    (
                                                                        (tableData?.getUserMasterData)?.map((user, index) => (
                                                                            <tr key={index} className={`TableTrhover ${highlightedRowIndex === index ? 'highlighted' : ''}`} onClick={() => handleHighlight(index)} >
                                                                                <td>
                                                                                    <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(user.edit)}>
                                                                                        <i className="bi bi-pencil-square" />
                                                                                    </button>

                                                                                </td>
                                                                                <td>
                                                                                    <button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => handleDeleteConfirm(user.del)}>
                                                                                        <i className="bi bi-trash3" />
                                                                                    </button>
                                                                                </td>
                                                                                <td>{user.userCode}</td>
                                                                                <td>{user.salesPersonCode}</td>
                                                                                <td>{user.userName}</td>
                                                                                <td>{user.groupName}</td>
                                                                                <td>{user.warehouse}</td>
                                                                                <td>{user.emailID}</td>
                                                                                <td>{user.mobileNo}</td>
                                                                                <td>{user.dateofJoining}</td>
                                                                                <td>{user.address}</td>
                                                                                <td>{user.city}</td>
                                                                                <td>{user.pinCode}</td>
                                                                                <td>{user.active}</td>
                                                                                <td>{user.allowBackDateTransaction}</td>
                                                                                <td>{user.createdBy}</td>
                                                                                <td>{user.createdDate}</td>
                                                                                <td>{user.createdByIPAddress}</td>
                                                                                <td>{user.modifiedBy}</td>
                                                                                <td>{user.modifiedDate}</td>
                                                                                <td>{user.modifiedByIPAddress}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<></>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                (
                                                    <Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => setFilterData({ ...filterData, PageIndex: value.toString() })} shape="rounded" />)
                                                :
                                                (<></>)
                                            }


                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center' style={{ minHeight: '200px', paddingLeft: "500px" }}>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                                {SessionClear ? <ClearSession /> : <></>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}



export const GroupMasterTable = ({ loading, currentPageNo, handleChange, filterData, searchHandle, filterList, setColoredRow, ColoredRow, setFilterData, handleEditData, tableData, getGroupMasterData, handleDelete }) => {
    const [SessionClear, SetSessionClear] = useState(false);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const handleHighlight = (index) => {
        setHighlightedRowIndex(index === highlightedRowIndex ? null : index);
    };
    const DeleteHandleConfirm = (GroupID) => {
        Swal.fire({
            title: 'Do you want to Delete this Record ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                handleDelete(GroupID);
            }
        });
    }



    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(20)))
    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                <div className="filter-section d-flex gap-2">
                                    <span className=" d-flex gap-1">
                                        <span className='select_records_filter'>
                                            <select className='filter-select'
                                                placeholder='Please select'
                                                value={filterData.SearchFieldValue}
                                                onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                {filterList ? (filterList.map((item, index) => (
                                                    <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                ))) : (<></>)}
                                            </select>
                                        </span>
                                        <span className='select_records_filter' >
                                            <select className='filter-select' value={filterData.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                <option value="1">Exactly</option>
                                                <option value="2">Contains</option>
                                                <option value="3">Start With</option>
                                            </select>
                                        </span>
                                        <span className=' filter-search-bar d-flex gap-2 form-control'>
                                            <input
                                                name="query"
                                                value={filterData.SearchText}
                                                onChange={(e) => {
                                                    setFilterData({ ...filterData, SearchText: e.target.value });
                                                }}
                                                placeholder="Search"
                                                title="Enter search keyword"
                                            />
                                            <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                searchHandle();
                                            }}>
                                                <i className="bi bi-search" />
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData.length !== 0 ?
                                                    (
                                                        tableData.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    <th>{"Edit"}</th>
                                                                    <th>{"Del"}</th>
                                                                    <th>{tableData.hGroupName}</th>
                                                                    <th>{tableData.hActive}</th>
                                                                    <th>{tableData.hAllowBackDateTransaction}</th>
                                                                    <th>{tableData.hCreatedBy}</th>
                                                                    <th>{tableData.hCreatedDate}</th>
                                                                    <th>{tableData.hCreatedByIPAddress}</th>
                                                                    <th>{tableData.hModifiedBy}</th>
                                                                    <th>{tableData.hModifiedDate}</th>
                                                                    <th>{tableData.hModifiedByIPAddress}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData.getData !== null ?
                                                                    (
                                                                        (tableData.getData).map((user, index) => (
                                                                            <tr key={index} className={`TableTrhover ${highlightedRowIndex === index ? 'highlighted' : ''}`} onClick={() => handleHighlight(index)}>
                                                                                <td>
                                                                                    <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(user.edit)}>
                                                                                        <i className="bi bi-pencil-square" />
                                                                                    </button>
                                                                                </td>
                                                                                <td>
                                                                                    <button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => DeleteHandleConfirm(user.del)}>
                                                                                        <i className="bi bi-trash3" />
                                                                                    </button>
                                                                                </td>
                                                                                <td>{user.groupName}</td>
                                                                                <td>{user.active}</td>
                                                                                <td>{user.allowBackDateTransaction}</td>
                                                                                <td>{user.createdBy}</td>
                                                                                <td>{user.createdDate}</td>
                                                                                <td>{user.createdByIPAddress}</td>
                                                                                <td>{user.modifiedBy}</td>
                                                                                <td>{user.modifiedDate}</td>
                                                                                <td>{user.modifiedByIPAddress}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<></>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                (
                                                    <Pagination count={countNo} variant="outlined" page={parseInt(filterData.PageIndex)} onChange={(event, value) => setFilterData({ ...filterData, PageIndex: value.toString() })} shape="rounded" />)
                                                :
                                                (<></>)
                                            }

                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center' style={{ minHeight: '200px', paddingLeft: "500px" }}>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                                {SessionClear ? <ClearSession /> : <></>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}